<div data-cy="player-list">
  @if (players().length > 0) {
    <div class="search-row">
      <div class="input-group">
        <input type="text" placeholder="Search for Players by Name, Hometown, Country, State, or ID"
          class="input form-control" [ngModel]="searchText()" (ngModelChange)="searchText.set($event)"
          (keyup.enter)="filterPlayers()" (input)="filterPlayers()" data-cy="search-input" />
          <span class="input-group-btn">
            <button type="button" class="btn btn btn-primary" (click)="filterPlayers()" data-cy="search-button">
              <i class="fa fa-search"></i> Search
            </button>
            <button type="button" class="btn btn btn-secondary" (click)="clearSearch()" data-cy="clear-button"
              title="Clear search">
              <i class="fa fa-times"></i>
            </button>
          </span>
        </div>
      </div>
    }

    @if (filteredPlayers().length > 0) {
      <div class="table-container">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>
                <app-sortable-header column="lpgaId" [sortConfig]="sortConfig()" (sort)="onSort($event)">
                  LPGA ID
                </app-sortable-header>
              </th>
              <th>
                <app-sortable-header column="wwgrId" [sortConfig]="sortConfig()" (sort)="onSort($event)">
                  WWGR ID
                </app-sortable-header>
              </th>
              <th>
                <app-sortable-header column="playLastName" [sortConfig]="sortConfig()" (sort)="onSort($event)">
                  Name
                </app-sortable-header>
              </th>
              <th>
                <app-sortable-header column="hometown" [sortConfig]="sortConfig()" (sort)="onSort($event)">
                  Hometown
                </app-sortable-header>
              </th>
              <th>
                <app-sortable-header column="shortName" [sortConfig]="sortConfig()" (sort)="onSort($event)">
                  Short Name
                </app-sortable-header>
              </th>
              <th>
                <app-sortable-header column="countryName" [sortConfig]="sortConfig()" (sort)="onSort($event)">
                  Country
                </app-sortable-header>
              </th>
              <th>
                <app-sortable-header column="stateName" [sortConfig]="sortConfig()" (sort)="onSort($event)">
                  State
                </app-sortable-header>
              </th>
              <th>
                <app-sortable-header column="isActive" [sortConfig]="sortConfig()" (sort)="onSort($event)">
                  Active
                </app-sortable-header>
              </th>
            </tr>
          </thead>
          <tbody>
            @for (player of paginationResult().items; track player; let i = $index) {
              <tr data-cy="player-row">
                <td>
                  {{ player.lpgaId }}
                </td>
                <td>
                  {{ player.wwgrId }}
                </td>
                <td>
                  <a [routerLink]="'/players/' + player.playerId" class="player-name-link">
                    {{ player.playLastName }}, {{ player.playFirstName }}
                  </a>
                </td>
                <td>{{ player.hometown }}</td>
                <td>{{ player.shortName }}</td>
                <td>{{ player.countryName }}</td>
                <td>{{ player.stateName }}</td>
                <td>
            <i class="fa" [ngClass]="{
                'fa-check text-success': player.isActive,
                'fa-times text-danger': !player.isActive
              }"></i>
                </td>
              </tr>
            }
          </tbody>
        </table>
        <!-- Pagination Component -->
        <app-table-pagination [paginationData]="paginationResult()" [itemDescriptor]="'Players'"
          (pageChange)="onPageChange($event)">
        </app-table-pagination>
      </div>
    }

    @if (filteredPlayers().length === 0 && players().length === 0) {
      <div class="alert alert-info">
        <i class="fa fa-info-circle"></i> No players found.
      </div>
    }

    @if (filteredPlayers().length === 0 && players().length > 0) {
      <div class="alert alert-warning"
        data-cy="no-players-message">
        <i class="fa fa-exclamation-triangle"></i> No players match your search criteria.
      </div>
    }
  </div>